import * as Route from '../config/routes';
import {history, store} from '../store/store'
import {hideNotification} from "../store/actions/notification";

export const goToForgotPassword = () => {
  goToLink(Route.ROUTE_FORGOT_PASSWORD);
};

export const goToLogin = () => {
  goToLink(Route.ROUTE_LOGIN);
};

export const goToResendActivationEmail = () => {
  goToLink(Route.ROUTE_RESEND_ACTIVATION);
};

export const goToLink = (link, clearNotification = true) => {
  if (history.location.pathname === link) return false;
  if (clearNotification) {
    store.dispatch(hideNotification());
  }

  history.push(link);
}
